import "./App.css";

import "bootstrap/dist/css/bootstrap.min.css";
import MainWrapper from "./Components/MainWrapper";
function App() {
  return (
    <div className="  bg-gray-300 h-screen  ">
      <div className="justify-evenly ">
        <MainWrapper />
      </div>
    </div>
  );
}

export default App;
